// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-filter-sub-menu_category_filter_sub_menu_box_section__gQ5o4 {
    z-index: 3;
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    align-items: center;
    justify-content: center;
        /* position: fixed; */
    z-index: 1000;
}

.category-filter-sub-menu_category_filter_sub_menu__0G6vB {
    width: 100%;
    height: 184px;
    display: flex;
    flex-wrap: wrap;
    max-width: 350px;
    margin-top: 5px;
    border-radius: 20px;
    align-items: center;
    justify-content: center;
    background-color: #24261F;
}

.category-filter-sub-menu_filter_box_header__HJAzX {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.category-filter-sub-menu_filter_box_body__o-gWP {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 10px;
    justify-content: flex-start;
}

.category-filter-sub-menu_category_box_header__t\\+25i {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.category-filter-sub-menu_category_box_body__TQr\\+t {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 10px;
    justify-content: flex-start;
}

.category-filter-sub-menu_filter_title_text__LevP8 {
    font-size: 10px;
    color: #FFFFFF;
    text-align: left;
}

.category-filter-sub-menu_filter_option_box__a7E7e {
    width: 100%;
    margin: 2px;
    height: 25px;
    display: flex;
    cursor: pointer;
    flex-wrap: wrap;
    max-width: 75px;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 50px;
    align-items: center;
    transition: all 0.2s;
    justify-content: center;
    background-color: #191A17;
}
.category-filter-sub-menu_filter_option_box__a7E7e.category-filter-sub-menu_active__2KPNA {
    color: #000000 !important;
    background-color: #AAFF00 !important;
}
.category-filter-sub-menu_filter_option_box__a7E7e.category-filter-sub-menu_active__2KPNA p {
    color: #000000 !important;
}
.category-filter-sub-menu_filter_option_box__a7E7e p {
    margin: 0;
    font-size: 10px;
    color: #FFFFFF;
}

.category-filter-sub-menu_category_filter_sub_menu__0G6vB hr {
    width: 100%;
    max-width: 260px;
    border: 2px solid #D6E5B8;
}

.category-filter-sub-menu_backdrop__NaIVo {
    inset: 0;
    position: fixed;
    z-index: 999;
    backdrop-filter: blur(2px);
    background: rgba(0, 0, 0, 0.25);
    -webkit-backdrop-filter: blur(2px);
}


@media (min-width: 1200px) {
    .category-filter-sub-menu_category_filter_sub_menu__0G6vB {
        width: 100%;
        height: 375px;
        margin-top: 10px;
        max-width: 1340px;
        border-radius: 50px;
    }
    .category-filter-sub-menu_category_filter_sub_menu__0G6vB hr {
        width: 100%;
        max-width: 1135px;
        border: 3px solid #D6E5B8;
    }

    .category-filter-sub-menu_filter_box_body__o-gWP {
        margin-left: 40px;
        justify-content: flex-start;
    }

    .category-filter-sub-menu_category_box_body__TQr\\+t {
        margin-left: 40px;
        justify-content: flex-start;
    }

    .category-filter-sub-menu_filter_title_text__LevP8 {
        font-size: 20px;
    }

    .category-filter-sub-menu_filter_option_box__a7E7e {
        width: 100%;
        margin: 2px;
        height: 50px;
        max-width: 150px;
    }
    .category-filter-sub-menu_filter_option_box__a7E7e p {
        font-size: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/category-filter-sub-menu/category-filter-sub-menu.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;QACnB,qBAAqB;IACzB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,0BAA0B;IAC1B,+BAA+B;IAC/B,kCAAkC;AACtC;;;AAGA;IACI;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".category_filter_sub_menu_box_section {\r\n    z-index: 3;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    position: absolute;\r\n    align-items: center;\r\n    justify-content: center;\r\n        /* position: fixed; */\r\n    z-index: 1000;\r\n}\r\n\r\n.category_filter_sub_menu {\r\n    width: 100%;\r\n    height: 184px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    max-width: 350px;\r\n    margin-top: 5px;\r\n    border-radius: 20px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #24261F;\r\n}\r\n\r\n.filter_box_header {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.filter_box_body {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    margin-left: 10px;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.category_box_header {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.category_box_body {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    margin-left: 10px;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.filter_title_text {\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n    text-align: left;\r\n}\r\n\r\n.filter_option_box {\r\n    width: 100%;\r\n    margin: 2px;\r\n    height: 25px;\r\n    display: flex;\r\n    cursor: pointer;\r\n    flex-wrap: wrap;\r\n    max-width: 75px;\r\n    user-select: none;\r\n    border-radius: 50px;\r\n    align-items: center;\r\n    transition: all 0.2s;\r\n    justify-content: center;\r\n    background-color: #191A17;\r\n}\r\n.filter_option_box.active {\r\n    color: #000000 !important;\r\n    background-color: #AAFF00 !important;\r\n}\r\n.filter_option_box.active p {\r\n    color: #000000 !important;\r\n}\r\n.filter_option_box p {\r\n    margin: 0;\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.category_filter_sub_menu hr {\r\n    width: 100%;\r\n    max-width: 260px;\r\n    border: 2px solid #D6E5B8;\r\n}\r\n\r\n.backdrop {\r\n    inset: 0;\r\n    position: fixed;\r\n    z-index: 999;\r\n    backdrop-filter: blur(2px);\r\n    background: rgba(0, 0, 0, 0.25);\r\n    -webkit-backdrop-filter: blur(2px);\r\n}\r\n\r\n\r\n@media (min-width: 1200px) {\r\n    .category_filter_sub_menu {\r\n        width: 100%;\r\n        height: 375px;\r\n        margin-top: 10px;\r\n        max-width: 1340px;\r\n        border-radius: 50px;\r\n    }\r\n    .category_filter_sub_menu hr {\r\n        width: 100%;\r\n        max-width: 1135px;\r\n        border: 3px solid #D6E5B8;\r\n    }\r\n\r\n    .filter_box_body {\r\n        margin-left: 40px;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .category_box_body {\r\n        margin-left: 40px;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .filter_title_text {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .filter_option_box {\r\n        width: 100%;\r\n        margin: 2px;\r\n        height: 50px;\r\n        max-width: 150px;\r\n    }\r\n    .filter_option_box p {\r\n        font-size: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category_filter_sub_menu_box_section": `category-filter-sub-menu_category_filter_sub_menu_box_section__gQ5o4`,
	"category_filter_sub_menu": `category-filter-sub-menu_category_filter_sub_menu__0G6vB`,
	"filter_box_header": `category-filter-sub-menu_filter_box_header__HJAzX`,
	"filter_box_body": `category-filter-sub-menu_filter_box_body__o-gWP`,
	"category_box_header": `category-filter-sub-menu_category_box_header__t+25i`,
	"category_box_body": `category-filter-sub-menu_category_box_body__TQr+t`,
	"filter_title_text": `category-filter-sub-menu_filter_title_text__LevP8`,
	"filter_option_box": `category-filter-sub-menu_filter_option_box__a7E7e`,
	"active": `category-filter-sub-menu_active__2KPNA`,
	"backdrop": `category-filter-sub-menu_backdrop__NaIVo`
};
export default ___CSS_LOADER_EXPORT___;
